export enum CONTRACTOR_TYPES {
  Buyer = "Buyer",
  Payer = "Payer",
  Receiver = "Receiver",
  Seller = "Seller",
  OrganizationalUnit = "OrganizationalUnit",
  Provider = "Provider",
}
